export class AzureFilesBackupSchedules {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "targetRegion",
            "baseName": "targetRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "scheduleConfig",
            "baseName": "scheduleConfig",
            "type": "StandardBackupScheduleConfig",
            "format": ""
        },
        {
            "name": "backupRetentionDays",
            "baseName": "backupRetentionDays",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return AzureFilesBackupSchedules.attributeTypeMap;
    }
    constructor() {
    }
}
